import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import './location-nav.scss';
import { Popover } from 'antd';
import { showLocationSearchModal } from 'hb-redux-store/feature/modal/modal.action';
import { getHomePageSection } from 'hb-redux-store/feature/home/home.action';
import AnalyticsService from 'AnalyticsService';

const LocationNav = ({
  launchInfo,
  showLocationSearchModal,
  tabName,
  getHomePageSection,
}) => {
  const showPopover = !(launchInfo.area && launchInfo.addressLine2);
  const [fadeAway, setFade] = useState('');
  let {
    area = 'Hello',
    addressLine2 = 'Select your location to help us serve you better',
  } = launchInfo;
  if (launchInfo.addressType) {
    addressLine2 = area;
    area = launchInfo.addressType;
  }
  useEffect(() => {
    if (showPopover) {
      const onScroll = e => {
        const top = e.target.documentElement.scrollTop;
        if (top > 10) {
          setFade('fade-away');
        } else {
          setFade('');
        }
      };
      window.addEventListener('scroll', onScroll);
      return () => window.removeEventListener('scroll', onScroll);
    }
  });

  const locationPopoverContent = (
    <div>
      <div className="desktop-choose-location--text">
        Please select an address so that we can serve you better
      </div>
      <Link
        to="#"
        onClick={() =>
          showLocationSearchModal({
            locationSearchModal: true,
            typeOfCTA: 'location',
          })
        }
        className="button medium more button-tertiary choose-location--cta"
      >
        SELECT ADDRESS
      </Link>
    </div>
  );
  return tabName !== 'USER' ? (
    <Popover
      overlayClassName={`desktop-choose-location--popover ${fadeAway}`}
      content={locationPopoverContent}
      visible={showPopover}
      placement="bottomLeft"
      onVisibleChange={() => {
        // Clevertap Analytics
        const key = 'Search Location';
        AnalyticsService.clevertap.sendCleverTapEvent(key);
      }}
    >
      <div className="desktop-location-nav">
        <div className="desktop-location-nav--location-detail">
          <div className="desktop-location-nav--location-detail--primary-text">
            {area}
          </div>
          <div className="justify-content--space-between">
            <div className="desktop-location-nav--location-detail--secondary-text ellipsis">
              {addressLine2}
            </div>
            <div className="desktop-location-nav--location-detail--secondary-text arrow"></div>
          </div>
        </div>
      </div>
    </Popover>
  ) : (
    <div className="desktop-location-nav">
      <div className="desktop-location-nav--location-detail">
        <div className="desktop-location-nav--location-detail--primary-text">
          {area}
        </div>
        <div className="justify-content--space-between">
          <div className="desktop-location-nav--location-detail--secondary-text ellipsis">
            {addressLine2}
          </div>
          <div className="desktop-location-nav--location-detail--secondary-text arrow"></div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = ({ initialReducer }) => ({
  launchInfo: initialReducer.launchInfo,
});
const mapDispactchToProps = { showLocationSearchModal, getHomePageSection };

export default connect(mapStateToProps, mapDispactchToProps)(LocationNav);
